package com.appcreator.compose.extensions

import com.appcreator.compose.extensions.date.dateformat
import kotlin.js.Date

actual fun format(date: String, from: String, to: String): String {
    if (date.isEmpty()) return ""
    val jsDate = Date(date)
    return dateformat.default(jsDate, "dddd dS mmmm")
}